import { FC } from "react";
import {
  TICKET_BODY_MAX_LENGTH,
  TICKET_SUBJECT_MAX_LENGTH,
} from "entities/support-ticket";
import type { CreateTicketResponse } from "entities/support-ticket";
import { FormInput, FormTextarea, formStyles as styles } from "shared/ui";
import { useCreateTicket } from "../model/useCreateTicket";

interface Props {
  onCreated?: (ticket: CreateTicketResponse) => void;
}

export const CreateTicketForm: FC<Props> = ({ onCreated }) => {
  const form = useCreateTicket(onCreated);

  return (
    <form
      className={styles.form}
      noValidate
      onSubmit={(event) => {
        event.preventDefault();
        form.submit();
      }}
    >
      <FormInput
        placeholder="Subject"
        maxLength={TICKET_SUBJECT_MAX_LENGTH}
        value={form.values.subject}
        error={form.errors.subject}
        onValueChange={(value) => form.setValue("subject", value)}
        disabled={form.isSubmitting}
        autoFocus
      />
      <FormTextarea
        placeholder="Describe your issue"
        rows={6}
        maxLength={TICKET_BODY_MAX_LENGTH}
        value={form.values.body}
        error={form.errors.body}
        onValueChange={(value) => form.setValue("body", value)}
        disabled={form.isSubmitting}
      />
      {form.serverError && <p className={styles.error}>{form.serverError}</p>}
      <button
        type="submit"
        className={styles.submitButton}
        disabled={form.isSubmitting}
      >
        {form.isSubmitting ? "Sending..." : "Send"}
      </button>
    </form>
  );
};
